module.exports = __webpack_public_path__ + "img/multi-site-screen.5205dfcb.svg";